import { useQuery } from '@tanstack/react-query';
import { GeogroupService } from '../services';
import { queryKeys } from './query-keys';
function useGeogroupQuery(geoGroupId) {
  return useQuery({
    queryKey: queryKeys.geogroup.all(geoGroupId),
    queryFn: () => GeogroupService.getGeogroup({
      geoGroupId: geoGroupId
    }),
    enabled: geoGroupId !== undefined,
    staleTime: Infinity
  });
}
export default useGeogroupQuery;